import {Grid} from '@logistics-frontend/blocks'
import React from 'react'

import {Props} from '../../../../shared/address'
import {Apartment, DoorCode, Entrance, Floor} from './address-details'

const HomeAddress: React.FC<Props> = ({index, length}) => {
  return (
    <>
      <Grid md={3} xs={6} item>
        <Entrance index={index} length={length} />
      </Grid>
      <Grid md={3} xs={6} item>
        <Floor index={index} length={length} />
      </Grid>
      <Grid md={3} xs={6} item>
        <Apartment index={index} length={length} />
      </Grid>
      <Grid md={3} xs={6} item>
        <DoorCode index={index} length={length} />
      </Grid>
    </>
  )
}

export default HomeAddress
